document.addEventListener('DOMContentLoaded', function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;

    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      details.open = true;
    });

    menu.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      closeTimer = setTimeout(function () {
        details.open = false;
      }, 150);
    });

    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (mq.matches) e.preventDefault();
      });
    }
  });

  var accordions = document.querySelectorAll('[data-hover-accordion]');

  accordions.forEach(function (accordion) {
    var closeTimer;

    accordion.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      accordion.classList.add('is-open');
    });

    accordion.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      closeTimer = setTimeout(function () {
        accordion.classList.remove('is-open');
      }, 200);
    });

    // Táctil/click: (hover: hover) nunca es true en móvil, así que el
    // desplegable necesita abrirse también con un tap explícito sobre el
    // propio título ("Catálogo"), no solo con el hover del ratón.
    var trigger = accordion.querySelector('[data-hover-accordion-trigger]');
    if (trigger) {
      var toggleAccordion = function () {
        var isOpen = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        accordions.forEach(function (other) {
          if (other === accordion) return;
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('[data-hover-accordion-trigger]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });
      };

      trigger.addEventListener('click', toggleAccordion);

      // El trigger es un span[role="button"] (no un <button> real) a propósito:
      // el <menu-drawer> nativo de Dawn cierra todo el cajón al pulsar
      // cualquier <button> que encuentre dentro (pensado para botones de
      // "volver" en submenús), así que un <button> aquí cerraría el drawer
      // justo al abrir la categoría. Al no ser un <button>, necesita
      // activación por teclado explícita para accesibilidad.
      trigger.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        toggleAccordion();
      });
    }
  });
});
